// datatable related plugins
import Breadcrumb from "components/Common/Breadcrumb";
import ConfirmModal from "components/shared-components/ConfirmModal";
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import { TEMPLATE_UPLOAD_CTKT } from "constants/CampaignInvoiceConstant";
import { ALL_BU, ALL_STORE } from "constants/DashboardContanst";
import {
  APPROVE_STATUS_A,
  APPROVE_STATUS_M,
  APPROVE_STATUS_P,
  APPROVE_STATUS_R,
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_AR,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_WARNING,
} from "constants/FormatDataContanst";
import { TYPE_ACTION_WORKFLOW } from "constants/IssueInvoiceConstant";
import { CUSTOM_DATE_FILTER_TABLE_TYPE } from "constants/RemoteDataTableContanst";
import jwt_decode from "jwt-decode";
import NoteModal from "pages/DataFormatInvoice/modal/NoteModal";
import { tableFormateDate } from "pages/DataFormatInvoice/utils";
import { TYPE_REPORT } from "pages/ReportInvoiceError/helper/functionHelper";
import React, { useEffect, useState } from "react";
import {
  customFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useParams } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import {
  Badge,
  Button,
  ButtonDropdown,
  Card,
  CardBody,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
} from "reactstrap";
import {
  actionWorkflowIssueInvoice,
  releaseTaxDeduct,
  resetActionWorkflowIssueInvoice,
  resetReleaseCampaignsInvoice,
  resetUploadCampaignsInvoice,
} from "store/actions";
import {
  AUTH_TOKEN,
  ROLE_EINVOICE_CUA_HANG,
  ROLE_EINVOICE_KE_TOAN,
} from "store/auth/login/actionTypes";
import {
  ACTION_WORKFLOW_ISSUE_INVOICE_FAIL,
  ACTION_WORKFLOW_ISSUE_INVOICE_SUCCESS,
  RELEASE_TAX_DEDUCT_FAIL,
  RELEASE_TAX_DEDUCT_SUCCESS,
  UPLOAD_TAX_DEDUCT_FAIL,
  UPLOAD_TAX_DEDUCT_SUCCESS,
} from "store/issue-invoice/actionTypes";
import {
  downloadReportInvoice,
  executeTaxDeductReport,
  getReportInvoiceList,
  resetDownloadReportInvoice,
  resetExecuteTaxDeductReport,
  resetReportInvoiceList,
  setColumnVisibleReportInvoiceList,
} from "store/summary-invoice-data/actions";
import {
  DOWNLOAD_REPORT_INVOICE_FAIL,
  DOWNLOAD_REPORT_INVOICE_SUCCESS,
  EXECUTE_TAX_DEDUCT_REPORT_FAIL,
  EXECUTE_TAX_DEDUCT_REPORT_SUCCESS,
} from "store/summary-invoice-data/actionTypes";
import { getReportStatus } from "../helper/functionHelper";
import ErrorModal from "../modal/ErrorUploadModal";
import UploadFileAttack from "../modal/UploadFileAttack";
import { COMMON_CONDITION_VISIBLE, getTypeWorkflowMessage } from "../utils";
import DetailReport from "./DetailReport";

const ListBathImport = props => {
  // modalError
  const [error, setError] = useState(null);
  const [modalError, setModalError] = useState(false);
  const toggleErrorModal = () => setModalError(!modalError);

  const [modalDetail, setModalDetail] = useState(false);
  const [dataDetail, setDataDetail] = useState(null);
  const toggleViewDetailModal = () => setModalDetail(!modalDetail);

  const [modalUploadFile, setModalUploadFile] = useState(false);
  const toggleUploadFileModal = () => setModalUploadFile(!modalUploadFile);

  // Workflow modal
  const [modalWorkflow, setModalWorkflow] = useState(false);
  const toggleWorkflowModal = () => setModalWorkflow(!modalWorkflow);
  const [dataWorkflow, setDataWorkflow] = useState({
    id: null,
    typeWorkflow: null,
    titleModal: null,
    bodyModal: null,
  });
  // Lí do từ chối duyệt
  const [noteReject, setNoteReject] = useState(null);
  const [modalReject, setModalReject] = useState(false);
  const toggleRejectModal = () => setModalReject(!modalReject);
  // Confirm Release modal
  const [modalConfirmRelease, setModalConfirmRelease] = useState(false);
  const toggleConfirmReleaseModal = () =>
    setModalConfirmRelease(!modalConfirmRelease);
  const [idRelease, setIdRelease] = useState(null);
  const openReleaseModal = id => {
    setIdRelease(id);
    toggleConfirmReleaseModal();
  };

  const { addToast } = useToasts();

  const [columns, setColumns] = useState([]);

  const dispatch = useDispatch();

  //ROLE_EINVOICE_CUA_HANG thì ẩn nút phát hành
  const [isRoleStore, setIsRoleStore] = useState(false);
  const [isRoleAccountant, setIsRoleAccountant] = useState(false);

  // Button download template
  const [isOpenDownloadTemplate, setIsOpenDownloadTemplate] = useState(false);
  const toggleOpenDownloadTemplate = () =>
    setIsOpenDownloadTemplate(!isOpenDownloadTemplate);

  // store reducer
  const issueInvoice = useSelector(state => state.issueInvoice);
  const { type, uploadTaxDeductData, releaseTaxDeductData, workflowInvoice } =
    issueInvoice;

  // store reducer
  const summaryInvoiceData = useSelector(state => state.summaryInvoiceData);
  const {
    type: typeReport,
    fileDownload: fileDownloadReport,
    fileDownloadName: fileDownloadNameReport,
  } = summaryInvoiceData;

  const { loading, listData, totalCount, columnsVisible, params } =
    summaryInvoiceData.reportInvoiceList;
  const history = useHistory();

  const { t, i18n } = useTranslation(["summaryInvoiceData"]);

  const [commonStatus, setCommonStatus] = useState(getReportStatus(t));

  useEffect(() => {
    setCommonStatus(getReportStatus(t));
  }, [t]);

  useEffect(() => {
    initColumn();
  }, [commonStatus]);

  const { id: idDetail } = useParams();
  useEffect(() => {
    if (idDetail) {
      setDataDetail({
        id: idDetail,
      });
      toggleViewDetailModal();
    }
  }, [idDetail]);

  useEffect(() => {
    let mess = "";
    // console.log("🚀 ~ file: ListBathImport.js:183 ~ useEffect ~ type", type);
    // console.log(
    //   "🚀 ~ file: ListBathImport.js:248 ~ useEffect ~ workflowInvoice",
    //   workflowInvoice
    // );
    console.log("🚀 ~ type saga", { type });
    switch (type) {
      case UPLOAD_TAX_DEDUCT_SUCCESS: {
        addToast("Upload đợt CTKT thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        setDataDetail({
          id: uploadTaxDeductData?.data?.id,
        });
        toggleViewDetailModal();
        toggleUploadFileModal();
        resetDataFunc();
        dispatch(resetUploadCampaignsInvoice());
        break;
      }
      case UPLOAD_TAX_DEDUCT_FAIL:
        addToast("Upload đợt CTKT thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetUploadCampaignsInvoice());
        break;
      case RELEASE_TAX_DEDUCT_SUCCESS: {
        addToast("Phát hành đợt CTKT thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        if (modalConfirmRelease) {
          toggleConfirmReleaseModal();
        }
        if (modalDetail) {
          toggleViewDetailModal();
          resetDataFunc();
        }
        resetDataFunc();
        dispatch(resetReleaseCampaignsInvoice());
        break;
      }
      case RELEASE_TAX_DEDUCT_FAIL:
        addToast("Phát hành đợt CTKT thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetReleaseCampaignsInvoice());
        break;
      case ACTION_WORKFLOW_ISSUE_INVOICE_SUCCESS:
        mess =
          getTypeWorkflowMessage(workflowInvoice.typeWorkflow) + " thành công";
        addToast(mess, {
          appearance: "success",
          autoDismiss: true,
        });
        if (modalWorkflow) {
          toggleWorkflowModal();
        }
        resetDataFunc();
        dispatch(resetActionWorkflowIssueInvoice());
        break;
      case ACTION_WORKFLOW_ISSUE_INVOICE_FAIL:
        mess =
          getTypeWorkflowMessage(workflowInvoice.typeWorkflow) + " thất bại";
        addToast(mess, {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetActionWorkflowIssueInvoice());
        break;
    }
  }, [type]);

  useEffect(() => {
    switch (typeReport) {
      case DOWNLOAD_REPORT_INVOICE_SUCCESS: {
        if (fileDownloadReport !== null) {
          const link = document.createElement("a");
          link.href = fileDownloadReport;
          link.setAttribute("download", fileDownloadNameReport);
          document.body.appendChild(link);
          link.click();
        }
        addToast("Tải xuống thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(resetDownloadReportInvoice());
        break;
      }
      case DOWNLOAD_REPORT_INVOICE_FAIL:
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetDownloadReportInvoice());
        break;
      case EXECUTE_TAX_DEDUCT_REPORT_SUCCESS: {
        if (!modalDetail) {
          addToast("Import đợt chứng từ thành công", {
            appearance: "success",
            autoDismiss: true,
          });
          resetDataFunc();
          dispatch(resetExecuteTaxDeductReport());
        }
        break;
      }
      case EXECUTE_TAX_DEDUCT_REPORT_FAIL:
        if (!modalDetail) {
          addToast("Import đợt chứng từ thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
          dispatch(resetExecuteTaxDeductReport());
        }
        break;
    }
  }, [typeReport]);

  const Dashboard = useSelector(state => state.Dashboard);
  const { tenantCodeHeader, finalBuInfo, buStoreHeader } = Dashboard;

  // Action list chang tenantCode
  useEffect(() => {
    if (finalBuInfo) {
      params.page = 1;
      dispatch(getReportInvoiceList(params, TYPE_REPORT.TAX_DEDUCT));
    }
  }, [finalBuInfo]);

  useEffect(() => {
    initColumn();
    //
    const info = jwt_decode(localStorage.getItem(AUTH_TOKEN));
    const roleUser = info["auth"];
    if (roleUser) {
      const listRole = info["auth"].split(",");
      setIsRoleStore(
        listRole.findIndex(item => item === ROLE_EINVOICE_CUA_HANG) !== -1
          ? true
          : false
      );
      setIsRoleAccountant(
        listRole.findIndex(item => item === ROLE_EINVOICE_KE_TOAN) !== -1
          ? true
          : false
      );
    }
    //
    return () => {
      dispatch(resetReportInvoiceList());
    };
  }, []);

  const initColumn = () => {
    if (Object.keys(columnsVisible).length !== 0) {
      for (const item of initColumns) {
        if (columnsVisible[item.dataField] !== undefined) {
          item.hidden = !columnsVisible[item.dataField];
        }
      }
    }
    setColumns(initColumns);
  };

  const rowEvents = {
    onDoubleClick: (e, row, rowIndex) => {
      openDetail(row);
    },
  };

  const openDetail = row => {
    setDataDetail({
      ...row,
    });
    toggleViewDetailModal();
  };

  const listRowAction = [
    // {
    //   icon: <i className="bx bx-send font-size-20 text-success" />,
    //   text: "Phát hành đợt chứng từ khấu trừ này",
    //   conditionVisible: COMMON_CONDITION_VISIBLE.RELEASE,
    //   onClick: row => {
    //     openReleaseModal(row.id);
    //   },
    // },
    {
      icon: <i className="bx bx-send text-primary" />,
      text: "Gửi duyệt đợt CTKT",
      isShow:
        finalBuInfo?.need_approve === 1 && (isRoleStore || isRoleAccountant),
      conditionVisible: COMMON_CONDITION_VISIBLE.SEND_APPROVE,
      onClick: row => {
        setDataWorkflow({
          id: row.id,
          typeWorkflow: TYPE_ACTION_WORKFLOW.SUBMIT,
          titleModal: "Xác nhận gửi duyệt đợt CTKT",
          bodyModal: "Hệ thống sẽ gửi duyệt đợt CTKT này",
        });
        toggleWorkflowModal();
      },
    },
    {
      icon: <i className="bx bxs-x-circle text-danger" />,
      text: "Từ chối duyệt đợt CTKT",
      isShow: finalBuInfo?.need_approve === 1 && isRoleAccountant,
      conditionVisible: COMMON_CONDITION_VISIBLE.REJECT,
      onClick: row => {
        setDataWorkflow({
          id: row.id,
          typeWorkflow: TYPE_ACTION_WORKFLOW.REJECT,
          titleModal: "Xác nhận từ chối duyệt đợt CTKT",
          bodyModal: "Lý do từ chối",
        });
        toggleWorkflowModal();
      },
    },
    {
      icon: <i className="bx bxs-check-circle text-success" />,
      text: "Duyệt đợt CTKT",
      isShow: finalBuInfo?.need_approve === 1 && isRoleAccountant,
      conditionVisible: COMMON_CONDITION_VISIBLE.APPROVE,
      onClick: row => {
        setDataWorkflow({
          id: row.id,
          typeWorkflow: TYPE_ACTION_WORKFLOW.APPROVE,
          titleModal: "Xác nhận duyệt đợt CTKT này",
          bodyModal: "Hệ thống sẽ duyệt và phát hành đợt CTKT này",
        });
        toggleWorkflowModal();
      },
    },
    {
      icon: <i className="fas fa-file-import font-size-20 text-info" />,
      text: "Import đợt chứng từ",
      conditionVisible: {
        // can_release: [true],
        // is_release: [0],
        ["auth_status"]: [AUTH_STATUS_WARNING, AUTH_STATUS_AR],
      },
      onClick: row => {
        dispatch(executeTaxDeductReport(row?.id));
      },
    },
    {
      icon: <i className="bx bx-download font-size-20 text-primary" />,
      text: "Download file đã upload",
      isShow: !modalDetail,
      onClick: row => {
        dispatch(
          downloadReportInvoice(
            row?.id,
            `ĐƠT_CTKT_${row?.id || ""}`,
            "blob",
            ".xlsx",
            TYPE_REPORT.TAX_DEDUCT
            //    +
            //   getTimeContent(row.parameters)
          )
        );
      },
    },
  ];

  const getAuthStatus = row => {
    let status = row.auth_status;
    let log = row.log;
    let infoError = null;
    if (status === AUTH_STATUS_REJECT || status === AUTH_STATUS_WARNING) {
      infoError = (
        <i
          style={{ cursor: "pointer" }}
          title="Hiển thị lỗi/cảnh báo"
          className="font-size-17 bx bx-info-circle text-danger"
          onClick={() => {
            setError(log);
            toggleErrorModal();
          }}
        ></i>
      );
    }
    return (
      <React.Fragment>
        <div className="d-flex gap-1">
          <Badge
            className={`font-size-12 ${commonStatus?.AUTH_STATUS[status]?.badgeColor}`}
            pill
          >
            {commonStatus?.AUTH_STATUS[status]?.text}
          </Badge>
          {infoError}
        </div>
      </React.Fragment>
    );
  };

  const selectFilterAuthStatus = {
    [AUTH_STATUS_NEW]: commonStatus?.AUTH_STATUS[AUTH_STATUS_NEW]?.text,
    [AUTH_STATUS_AR]: commonStatus?.AUTH_STATUS[AUTH_STATUS_AR]?.text,
    [AUTH_STATUS_APPROVE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_APPROVE]?.text,
    [AUTH_STATUS_PROGRESSING]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_PROGRESSING]?.text,
    [AUTH_STATUS_REJECT]: commonStatus?.AUTH_STATUS[AUTH_STATUS_REJECT]?.text,
    [AUTH_STATUS_WARNING]: commonStatus?.AUTH_STATUS[AUTH_STATUS_WARNING]?.text,
  };

  const getSelectFilterApproveStatus = () => {
    const filter = {};
    let listFilter = [
      APPROVE_STATUS_M,
      APPROVE_STATUS_P,
      APPROVE_STATUS_A,
      APPROVE_STATUS_R,
    ];
    // if (isRoleAccountant) {
    //   listFilter = [APPROVE_STATUS_P, APPROVE_STATUS_A];
    // }
    for (const item of listFilter) {
      if (selectFilterApproveStatus[item]) {
        filter[item] = selectFilterApproveStatus[item];
      }
    }
    return filter;
  };

  const selectFilterApproveStatus = {
    [APPROVE_STATUS_M]: commonStatus?.APPROVE_STATUS[APPROVE_STATUS_M]?.text, // "Lưu tạm",
    [APPROVE_STATUS_P]: commonStatus?.APPROVE_STATUS[APPROVE_STATUS_P]?.text, // "Gửi chờ duyệt",
    [APPROVE_STATUS_A]: commonStatus?.APPROVE_STATUS[APPROVE_STATUS_A]?.text, // "Đã duyệt",
    [APPROVE_STATUS_R]: commonStatus?.APPROVE_STATUS[APPROVE_STATUS_R]?.text, // "Từ chối duyệt",
  };

  const getApproveStatus = row => {
    let status = row.approve_status;
    let note_deny = row?.approve_note?.workflowNote;
    let infoError = null;
    if (status === APPROVE_STATUS_R) {
      infoError = (
        <i
          style={{ cursor: "pointer" }}
          title="Hiển thị lý do từ chối"
          className="font-size-17 bx bx-info-circle text-danger"
          onClick={() => {
            setNoteReject(note_deny);
            toggleRejectModal();
          }}
        ></i>
      );
    }
    return (
      <React.Fragment>
        <div className="d-flex gap-1" title={note_deny}>
          <Badge
            className={`font-size-12 ${commonStatus?.APPROVE_STATUS[status]?.badgeColor}`}
            pill
          >
            {commonStatus?.APPROVE_STATUS[status]?.text}
          </Badge>
          {infoError}
        </div>
      </React.Fragment>
    );
  };

  const initColumns = [
    {
      dataField: "id",
      text: "Id",
      sort: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { minWidth: "75px", maxWidth: "120px" },
      }),
    },
    {
      dataField: "bu_code",
      text: "Mã đơn vị",
      sort: true,
      // filter: textFilter({
      //   placeholder: t("placeholder.enter"),
      //   style: { width: "120px" },
      // }),
      formatter: (cellContent, row) => {
        return (
          <div style={{ maxWidth: "120px" }}>{row?.parameters?.bu_code}</div>
        );
      },
    },
    {
      dataField: "auth_status",
      text: "Trạng thái khởi tạo",
      hidden: false,
      formatter: (cellContent, row) => getAuthStatus(row),
      filter: selectFilter({
        placeholder: t("placeholder.select"),
        options: selectFilterAuthStatus,
      }),
    },
    {
      dataField: "approve_status",
      text: "Trạng thái duyệt",
      hidden: finalBuInfo?.need_approve === 0,
      formatter: (cellContent, row) => getApproveStatus(row),
      filter: selectFilter({
        placeholder: t("placeholder.select"),
        options: getSelectFilterApproveStatus(),
      }),
    },
    {
      dataField: "detail",
      text: "",
      hidden: false,
      formatter: (cellContent, row) => {
        return row.auth_status === AUTH_STATUS_APPROVE ? (
          <div
            onClick={() => {
              window.open("/tax-deduct/list?report_id=" + row.id, "_blank");
            }}
            style={{ textDecoration: "underline", cursor: "pointer" }}
            className="text-primary"
          >
            Xem chứng từ
          </div>
        ) : (
          <span className="text-warning">Chưa có chứng từ</span>
        );
      },
    },
    // {
    //   dataField: "release_all",
    //   text: "Trạng thái phát hành",
    //   hidden: false,
    //   formatter: (cellContent, row) => {
    //     let text = "";
    //     let badgeColor = "";
    //     if (cellContent) {
    //       text = "Đã phát hành tất cả";
    //       badgeColor = "badge-soft-success";
    //     } else {
    //       if (!row.can_release && row.auth_status === AUTH_STATUS_APPROVE) {
    //         text = "Đang phát hành đợt";
    //         badgeColor = "badge-soft-warning";
    //       } else {
    //         text = "Chưa phát hành";
    //         badgeColor = "badge-soft-secondary";
    //       }
    //     }
    //     return (
    //       <div className="d-flex gap-1">
    //         <Badge className={`font-size-12 ${badgeColor}`} pill>
    //           {text}
    //         </Badge>
    //       </div>
    //     );
    //   },
    //   //   filter: selectFilter({
    //   //     placeholder: t("placeholder.select"),
    //   //     options: selectFilterAuthStatus,
    //   //   }),
    // },
    // {
    //   dataField: "parameters.bu_code",
    //   text: "Mã chi nhánh/ đơn vị",
    //   sort: true,
    //   formatter: (cell, row) => {
    //     let textFinal = "";
    //     if (cell && Array.isArray(cell)) {
    //       const array = [];
    //       for (const item of cell) {
    //         const data = item;
    //         array.push(data);
    //       }
    //       textFinal = array.join(", ");
    //     } else {
    //       textFinal = row.bu_code;
    //     }
    //     return (
    //       <div
    //         className="text-info"
    //         style={{
    //           fontWeight: "bold",
    //           width: "200px",
    //           whiteSpace: "initial",
    //         }}
    //       >
    //         {textFinal}
    //       </div>
    //     );
    //   },
    // },
    {
      dataField: "checker_date",
      text: "Ngày tạo",
      hidden: false,
      formatter: (cellContent, row) => tableFormateDate(row.checker_date),
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={params.columnFilter}
        />
      ),
    },
  ];

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    params.sort = sortField ? sortOrder + sortField : params.sort;
    params.columnFilter = columnFilter;
    params.page = page;
    params.sizePerPage = sizePerPage;
    dispatch(getReportInvoiceList(params, TYPE_REPORT.TAX_DEDUCT));
  };

  const onSearchAllHandle = value => {
    params.keywords = value;
    dispatch(getReportInvoiceList(params, TYPE_REPORT.TAX_DEDUCT));
  };

  const optionShowColumnHandel = (field, value) => {
    const targetColumn = columns.find(item => item.dataField === field);
    if (targetColumn) {
      targetColumn.hidden = !value;
    }
    setColumns(columns);
    dispatch(setColumnVisibleReportInvoiceList(field, value));
  };

  const resetDataFunc = () => {
    dispatch(getReportInvoiceList(params, TYPE_REPORT.TAX_DEDUCT));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>DANH SÁCH ĐỢT CHỨNG TỪ KHẤU TRỪ THUẾ TNCN</title>
        </MetaTags>
        <div className="container-fluid">
          <Breadcrumb
            title=""
            breadcrumbItem={
              "DANH SÁCH ĐỢT CHỨNG TỪ KHẤU TRỪ THUẾ TNCN" + ` (${totalCount})`
            }
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <React.Fragment>
                    {/*Từ chối duyệt Modal */}
                    <NoteModal
                      isOpen={modalReject}
                      toggle={toggleRejectModal}
                      note={noteReject}
                      titleNote={"Lí do từ chối duyệt"}
                    />
                    {/* WORKFLOW modal */}
                    <ConfirmModal
                      isOpen={modalWorkflow}
                      titleHeader={dataWorkflow.titleModal}
                      titleBody={dataWorkflow.bodyModal}
                      isRequireNote={false}
                      isDisableButton={workflowInvoice.loading}
                      isHaveNote={
                        dataWorkflow.typeWorkflow ===
                        TYPE_ACTION_WORKFLOW.REJECT
                      }
                      onConfirm={note => {
                        dispatch(
                          actionWorkflowIssueInvoice(
                            dataWorkflow.id,
                            dataWorkflow.typeWorkflow,
                            note,
                            "tax-deduct-reports"
                          )
                        );
                      }}
                      textBtnConfirm={"Xác nhận"}
                      textBtnCancel={"Đóng"}
                      toggle={toggleWorkflowModal}
                    />
                    <DetailReport
                      isOpenModal={modalDetail}
                      t={t}
                      dataDetail={dataDetail}
                      toggleModal={toggleViewDetailModal}
                      resetListData={resetDataFunc}
                    />
                    <UploadFileAttack
                      isOpen={modalUploadFile}
                      toggle={toggleUploadFileModal}
                    />
                    <ErrorModal
                      isOpen={modalError}
                      error={error}
                      toggle={toggleErrorModal}
                    ></ErrorModal>
                    {/* Release */}
                    <ConfirmModal
                      isOpen={modalConfirmRelease}
                      titleHeader={
                        "Xác nhận phát hành đợt chứng từ khấu trừ này"
                      }
                      titleBody={
                        "Hệ thống sẽ thực hiện gửi phát hành đợt chứng từ này"
                      }
                      isDisableButton={releaseTaxDeductData.loading}
                      onConfirm={note => {
                        dispatch(releaseTaxDeduct(idRelease));
                      }}
                      textBtnConfirm={"Xác nhận"}
                      textBtnCancel={"Đóng"}
                      toggle={toggleConfirmReleaseModal}
                    />
                    <RemoteDataTable
                      keyField="id"
                      data={listData}
                      columns={columns}
                      page={params.page}
                      listRowAction={listRowAction}
                      sizePerPage={params.sizePerPage}
                      totalSize={totalCount}
                      loading={loading}
                      onTableChange={handleTableChange}
                      onSearchAllHandle={onSearchAllHandle}
                      optionShowColumnHandel={optionShowColumnHandel}
                      rowEvents={rowEvents}
                    >
                      {![ALL_BU, ALL_STORE].includes(buStoreHeader) && (
                        <Button
                          type="button"
                          color="primary"
                          className="me-2 btn-label"
                          onClick={() => {
                            toggleUploadFileModal();
                          }}
                        >
                          <i className="bx bx-upload label-icon" />
                          Upload chứng từ khấu trừ
                        </Button>
                      )}

                      <ButtonDropdown
                        className="me-2"
                        isOpen={isOpenDownloadTemplate}
                        toggle={toggleOpenDownloadTemplate}
                      >
                        <DropdownToggle
                          className="btn-label"
                          caret
                          color="info"
                          outline
                        >
                          <i className="bx bx-download label-icon" />
                          Tải template
                          <i
                            style={{ marginLeft: "5px" }}
                            className="mdi mdi-chevron-down"
                          />
                        </DropdownToggle>
                        <DropdownMenu
                          style={{ zIndex: 3, border: " 1px solid #808080d4" }}
                        >
                          <Link
                            to={`/file/${TEMPLATE_UPLOAD_CTKT}`}
                            target="_blank"
                            download
                            style={{ color: "white" }}
                          >
                            <DropdownItem
                              style={{ position: "relative" }}
                              className="d-flex gap-1 align-items-center"
                            >
                              <i
                                style={{ color: "green" }}
                                className="far fa-file-archive"
                              />{" "}
                              <span className="text-primary">
                                {TEMPLATE_UPLOAD_CTKT}
                              </span>
                            </DropdownItem>{" "}
                          </Link>
                        </DropdownMenu>
                      </ButtonDropdown>
                    </RemoteDataTable>
                  </React.Fragment>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListBathImport;
